import styled                      from 'styled-components';
import { CircularProgress, Paper } from '@mui/material';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.light,
  ...theme.typography.body2,
  marginBottom: 15,
  padding: 20,
  color: theme.palette.text.secondary,
}));

export const LoaderWrapper = styled.div`
  margin: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  & > svg {
    margin-top: -4px;
  }
`;

export const Progress = styled(CircularProgress)`
  opacity: 0.7;
`;

export const VehicleFeaturesLoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
